import { apiProxyRequest } from "Api/apiProxyRequest";

import type { EnvironmentTask, GetEnvironmentTasksRequestProps } from "./types";

/**
 * Fetches the task-container definitions for an environment. Returns every
 * declared task, including never-run ones.
 */
export const getEnvironmentTasksRequest = ({
  projectId,
  encodedEnvId
}: GetEnvironmentTasksRequestProps) =>
  apiProxyRequest<EnvironmentTask[]>(
    `/projects/${encodeURIComponent(projectId)}/environments/${encodedEnvId}/tasks`,
    "GET"
  );
